const autoNgTemplateLoaderTemplate1 = require('./node-details-view.html');

angular.module('portainer.docker').component('nodeDetailsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'NodeDetailsViewController',
});
